// Shared editorial-style section heading used across every home page section.
// Locks typography (Crimson Text · 4xl→6xl · semibold · negative tracking)
// in one place so titles cannot drift over time.
//
// Pass children directly; use <em> inside the children to apply the
// brand's italic-accent treatment on a key descriptor word.
//
//   <SectionHeading data-testid="foo-headline">
//     Inside the <em>Job Site</em>
//   </SectionHeading>

import React from 'react';

const TONE_CLASSES = {
  light: 'text-foreground',
  dark: 'text-bone',
};

export default function SectionHeading({
  as: Tag = 'h2',
  tone = 'light',
  size = 'default',
  className = '',
  children,
  ...rest
}) {
  const sizeClass =
    size === 'large'
      ? 'text-5xl sm:text-6xl lg:text-7xl'
      : 'text-4xl sm:text-5xl lg:text-6xl';
  const toneClass = TONE_CLASSES[tone] || TONE_CLASSES.light;
  return (
    <Tag
      className={`editorial-headline ${sizeClass} ${toneClass} ${className}`}
      {...rest}
    >
      {children}
    </Tag>
  );
}
